import { Route } from '@angular/router';

export const ROUTES: Route[] = [
  { path: '', redirectTo: '/demo', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () =>
      import('./pages/pages.routes').then((m) => m.PAGES_ROUTES),
  },
  { path: '**', redirectTo: '/demo' },
];
